import { api } from '../lib/api';

export interface Page {
  id: string;
  name: string;
  slug: string;
  icon?: string;
  description?: string;
  layout: any;
  components: any[];
  permissions?: { isLocked?: boolean; isHidden?: boolean; [key: string]: any };
  isHome: boolean;
  orderIndex: number;
  parentId?: string | null;
  children?: Page[];
  createdAt: string;
  updatedAt: string;
}

export const pageApi = {
  getAll: async (workspaceId: string) => {
    const response = await api.get(`/workspaces/${workspaceId}/pages`);
    return response.data;
  },

  getAllComponents: async (workspaceId: string) => {
    const response = await api.get(`/workspaces/${workspaceId}/pages/components/all`);
    return response.data;
  },

  getOne: async (workspaceId: string, slug: string) => {
    const response = await api.get(`/workspaces/${workspaceId}/pages/${slug}`);
    return response.data;
  },

  create: async (workspaceId: string, data: Partial<Page>) => {
    const response = await api.post(`/workspaces/${workspaceId}/pages`, data);
    return response.data;
  },

  update: async (workspaceId: string, slug: string, data: Partial<Page>) => {
    const response = await api.patch(`/workspaces/${workspaceId}/pages/${slug}`, data);
    return response.data;
  },

  updateData: async (workspaceId: string, slug: string, data: Partial<Page>) => {
    const response = await api.patch(`/workspaces/${workspaceId}/pages/${slug}/data`, data);
    return response.data;
  },

  delete: async (workspaceId: string, slug: string) => {
    const response = await api.delete(`/workspaces/${workspaceId}/pages/${slug}`);
    return response.data;
  },

  reorder: async (workspaceId: string, pageId: string, newOrder: number) => {
    const response = await api.patch(`/workspaces/${workspaceId}/pages/${pageId}/reorder`, {
      orderIndex: newOrder,
    });
    return response.data;
  },

  toggleLock: async (workspaceId: string, slug: string, isLocked: boolean) => {
    const response = await api.patch(`/workspaces/${workspaceId}/pages/${slug}/lock`, { isLocked });
    return response.data;
  },

  toggleHidden: async (workspaceId: string, slug: string, isHidden: boolean) => {
    const response = await api.patch(`/workspaces/${workspaceId}/pages/${slug}/visibility`, { isHidden });
    return response.data;
  },

  generateWithAI: async (workspaceId: string, prompt: string) => {
    const response = await api.post(`/workspaces/${workspaceId}/ai/generate-pages`, {
      prompt,
      provider: 'openai',
    });
    return response.data;
  },
};
